import { memo } from 'react';

import { Skeleton } from './notification-menu-spinner.styles';

const NotificationMenuSpinnerComponent = () => {
	return <Skeleton width="100%" height="22px" radius="6px" />;
};

export default memo(NotificationMenuSpinnerComponent);
